jQuery(document).ready(function () {
  jQuery.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});
 
function quickView() {
  jQuery(".quick-view").click(function () {
    if (jQuery('#quick-view').length == 0){jQuery("body").append('<div id="quick-view"></div>');}
    var product_handle = jQuery(this).data('handle');
    jQuery('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
     // console.log(product);
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var vendor = product.vendor;
      var tags = product.tags;
      var url = '/products/' + product_handle;
      
      jQuery('.qv-product-title').text(title);
      jQuery('.qv-product-type').html("<b>Type: </b>" +type);
      jQuery('.qv-product-vendor').html("<b>Vendor:</b> " +vendor);
      jQuery('.qv-product-description').html(desc);
      jQuery('.view-product').attr('href', url);
      var imageCount = jQuery(images).length;
      
      jQuery(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_500x.jpg').replace('.png', '_500x.png');
          jQuery('.qv-product-images').append(image_embed);
          jQuery('.qv-product-images').slick({
            'dots': true,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
 
        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_500x.jpg').replace('.png', '_500x.png');
          jQuery('.qv-product-images').append(image_embed);
        }
      });
      
      jQuery(options).each(function (i, option) {
        var opt = option.name.replace(/\s/g,'');
        var vt_opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        jQuery('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + vt_opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        jQuery(option.values).each(function (i, value) {
          jQuery('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });
      
      jQuery(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
          jQuery('.qv-add-to-cart').hide();
          jQuery('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          jQuery('.qv-product-price').text('$' +price);
          if (original_price > 0) {
            jQuery('.qv-product-original-price').text('$' + original_price).show();
          } else {
            jQuery('.qv-product-original-price').hide();
          }
          jQuery('select.option-0').val(v.option1);
          jQuery('select.option-1').val(v.option2);
          jQuery('select.option-2').val(v.option3);
          return false
        }
      });
    });
 
    jQuery(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      jQuery('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = jQuery(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + jQuery(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        jQuery(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            jQuery('.qv-product-price').text('$' + price);
            jQuery('.qv-product-original-price').text('$' + original_price);
            if (v_inv == null) {
              jQuery('.qv-add-button').prop('disabled', false).val('Add to Bag');
            } else {
              if (v.inventory_quantity < 1) {
                jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
              } else {
                jQuery('.qv-add-button').prop('disabled', false).val('Add to Bag');
              }
            }
          }
        });
      });
    });
    jQuery.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '90%',
      height: '80%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = jQuery('#quick-view').attr('class');
        jQuery(document).on("click", ".qv-add-button", function () {
          var qty = jQuery('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          jQuery('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = jQuery(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + jQuery(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            jQuery(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
              null,
              "json"
            ).done(function () {
              jQuery('.qv-add-to-cart-response').addClass('success').html('<span>' + jQuery('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
            })
            .fail(function (jQueryxhr) {
              var data = jQueryxhr.responseJSON;
              jQuery('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        jQuery('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        jQuery('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          jQuery('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        jQuery('#quick-view').removeClass().empty();
      }
    });
  });
};
 
jQuery(window).resize(function () {
  if (jQuery('#quick-view').is(':visible')) {
    jQuery('.qv-product-images').slick('setPosition');
  }
});


jQuery(document).ready(function(){
  jQuery("#cart_order").click(function(){
    jQuery("#CartSpecialInstructions").toggle();
  });
});



//Preloader
/* jQuery(document).ready(function() {
jQuery(window).on("load", function() {
preloaderFadeOutTime = 500;
function hidePreloader() {
var preloader = jQuery('.spinner-wrapper');
preloader.fadeOut(preloaderFadeOutTime);
}
hidePreloader(); 
});
});*/